export enum YearType {
  Buddhist = 'BE',
  AnnoDomini = 'AD'
}
